import { createSelector } from 'reselect';
import treeSelector from './tree';
import cwdSelector from './cwd';

const DEFAULT = {};

export default createSelector(treeSelector, cwdSelector, (tree, cwd) => tree[cwd] || DEFAULT);
